module.exports = __webpack_public_path__ + "barclays-center.d9066f23.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/images/neighborhood/full/barclays-center.jpg
// module id = 651
// module chunks = 0